import { Stack, Typography } from '@mui/material';
import { memo } from 'react';

import { VpToggle } from '@vp/common/ui/component/VpToggle';
import { ProfileAccessModel, Restriction } from '@vp/profile/core/model/ProfileAccessModel';

type Section = {
  id: Restriction;
  title: string;
};

const Sections: Section[] = [
  { id: Restriction.Bio, title: 'Биография' },
  { id: Restriction.Events, title: 'События' },
  { id: Restriction.Gallery, title: 'Галерея' },
  { id: Restriction.Honor, title: 'Почести' },
];

export type DetailedRestrictionPanelProps = {
  access: ProfileAccessModel;
  disabled: boolean;
  onSectionToggle: (section: Restriction) => void;
};

export const DetailedRestrictionPanel = memo<DetailedRestrictionPanelProps>(({ access, disabled, onSectionToggle }) => {
  return (
    <Stack
      sx={{
        backgroundColor: 'background.200',
        borderRadius: '12px',
        px: 2,
        py: 1,
      }}
    >
      {Sections.map((section, index) => {
        const last = index === Sections.length - 1;
        const state = access.restrictions.has(section.id);

        return (
          <Stack
            key={section.id}
            sx={{
              pl: 3,
              pr: 0.5,
              py: 2,
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              borderBottom: '1px solid',
              borderColor: !last ? 'transparency.alpha16' : 'transparent',
            }}
          >
            <Typography variant="body1Medium" color="text.secondary">
              {section.title}
            </Typography>

            <VpToggle state={state} disabled={disabled} onToggle={() => onSectionToggle(section.id)} />
          </Stack>
        );
      })}
    </Stack>
  );
});

DetailedRestrictionPanel.displayName = 'DetailedRestrictionPanel';
